import React, { useState } from "react";
import emailjs from "emailjs-com";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(null); // null | "success" | "error"
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      await emailjs.send(
        "service_mojhtmk",
        "template_qz62aka",
        formData,
        "rK7wapAKkWmYU8H91",
      );
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("Failed to send email.", err);
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  return (
    <section
      id="contact"
      className="py-16 bg-white dark:bg-black rounded-xl text-gray-600 dark:text-gray-300 px-10 transition-colors duration-300"
    >
      <h2 className="text-4xl text-center mb-8 text-gray-700 dark:text-gray-200">
        Contact
      </h2>
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          className="w-full p-2 mb-4 border border-gray-300 dark:border-gray-800 rounded bg-white dark:bg-transparent text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 hover:border-gray-500 dark:hover:border-gray-400 focus:border-sky-500 dark:focus:border-sky-400 focus:outline focus:outline-sky-500 dark:focus:outline-sky-400 transition-colors duration-200"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          className="w-full p-2 mb-4 border border-gray-300 dark:border-gray-800 rounded bg-white dark:bg-transparent text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 hover:border-gray-500 dark:hover:border-gray-400 focus:border-sky-500 dark:focus:border-sky-400 focus:outline focus:outline-sky-500 dark:focus:outline-sky-400 transition-colors duration-200"
          required
        />
        <textarea
          name="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleChange}
          className="w-full p-2 mb-4 border border-gray-300 dark:border-gray-800 rounded bg-white dark:bg-transparent text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 hover:border-gray-500 dark:hover:border-gray-400 focus:border-sky-500 dark:focus:border-sky-400 focus:outline focus:outline-sky-500 dark:focus:outline-sky-400 transition-colors duration-200"
          rows={5}
          required
        />

        {status === "success" && (
          <p className="mb-4 text-sm text-green-600 dark:text-green-400 text-center">
            Your message has been sent successfully!
          </p>
        )}
        {status === "error" && (
          <p className="mb-4 text-sm text-red-600 dark:text-red-400 text-center">
            Something went wrong. Please try again or email me directly.
          </p>
        )}

        <button
          type="submit"
          disabled={sending}
          className="w-full mt-2 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-lg px-10 py-2.5 text-center transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {sending ? "Sending..." : "Send"}
        </button>
      </form>
    </section>
  );
}

export default Contact;
